export const standardUpsellStats = ({mqlLabel, currUser, salLabel}) => [
        {
            "id": "upsellTransactions",
            "tab": "upsell",
            "visible": true,
            "order": 1,
            "voiceover": "This chart shows the number of upsell transactions.",
            link: "#upsellTransactions", title: "Transactions",
            "props": {
                "chartTitle": "upsell transactions",
                "chartDescription": "This chart shows the number of upsell transactions {segmentDescription}.",
                "chartColorId": "upsell transactions",
                "inputType": "integer",
                "legendLabel": "# Deals",
                "bottomLegendLabel": "Close Date",
                "trendLineEntry": "# Deals",
                "handleChartClick": "handleTransactionsChartClick",
                "usedInPredictions": false,
                "availableGlobalOnly": false,
                "drilldownAvailable": true,
                "maxValueMethod": "multiply" // static or multiply
            }
        },
        {
            "id": "upsellBookings",
            "tab": "upsell",
            "visible": true,
            "order": 2,
            "voiceover": "This chart shows the total upsell bookings.",
            link: "#bookings",
            title: "Bookings",
            "props": {
                "chartTitle": "upsell bookings",
                "chartDescription": "This chart shows the total upsell / expansion {acceptedBookingMetricString} booked {segmentDescription}.",
                "chartColorId": "upsell bookings",
                "inputType": "currency",
                "legendLabel": "{acceptedBookingMetricString}",
                "bottomLegendLabel": "Close Date",
                "trendLineEntry": "Closed Won",
                "handleChartClick": "handleBookingsChartClick",
                "usedInPredictions": false,
                "availableGlobalOnly": false,
                "drilldownAvailable": true,
                "maxValueMethod": "multiply",
            }
        },

        {
            id: 'upsellDealSize',
            "tab": "upsell",
            "visible": true,
            "order": 3,
            "voiceover": "This chart shows the upsell deal size.",
            link: "#upsellDealSize", title: "Average Deal Size",
            props: {
                chartTitle: 'upsell / expansion deal size',
                chartColorId: 'upsell / expansion deal size',
                usedInPredictions: false,
                availableGlobalOnly: false,
                drilldownAvailable: true,
                chartDescription: `This chart shows the average {acceptedBookingMetricString} associated with an upsell / expansion business transaction {segmentDescription}`,
                inputType: 'currency',
                bottomLegendLabel: 'Close Date',
                legendLabel: 'Average {acceptedBookingMetricString}',
                handleChartClick: 'handleDealSizeChartClick',
            },
        },

        {
            id: 'upsellWinRate',
            "visible": true,
            "order": 4,
            "voiceover": "This chart shows the upsell win rate.",
            link: "#winRate",
            title: "Win Rate",
            props: {
                chartTitle: 'upsell win rate',
                chartColorId: 'upsell win rate',
                usedInPredictions: true,
                availableGlobalOnly: false,
                drilldownAvailable: true,
                chartDescription: `This chart shows the upsell / expansion win rate transaction {segmentDescription} Of the opportunities reaching a qualified stage in a given {dateType}, this is the % won on a count basis.`,
                inputType: 'percent',
                bottomLegendLabel: 'Qualified Date',
                legendLabel: 'Win Rate',
                handleChartClick: 'handleWinRateChartClick',
                // Additional props for QPilot
                qPilotEnabled: false,
                qPilotChartName: 'gtm-stats-upsell-win-rate',
                // Note: qPilotChartDataSet will be handled in utility functions
                // Additional props for custom config
                enableCustomConfig: true,
                gtmStatsCustomConfigEntry: 'opp_win_rate',
            },
        },

        {
            id: 'upsellSalesCycle',
            "visible": true,
            "order": 5,
            "voiceover": "This chart shows the upsell sales cycle.",
            link: "#upselloppWinDays", title: "Sales Cycle",
            props: {
                chartTitle: 'upsell sales cycle',
                chartColorId: 'upsell sales cycle',
                drilldownAvailable: true,
                usedInPredictions: true,
                availableGlobalOnly: false,
                bottomLegend: "days",
                chartDescription: `This chart shows the sales cycle in days for upsell / expansion deals {segmentDescription} Sales cycle is measured in days between the date opp is qualified to the date opp is closed won.`,
                inputType: 'percent',
                bottomLegendLabel: 'days',
                legendLabel: '% Distribution',
                // handleChartClick: 'handleSalesCycleChartClick', // Use the correct handler
                handleDistroChartClick: "handleSalesCycleChartClickUpsell",
                isComposed: true,
                isDistroChart: true,
                showMarkers: false,
                showXMarkers: true,
                enableCustomConfig: true,
                trendLineEntry: 'curve_values',
            },
        },
        {
            id: 'renewalBookings',
            "visible": true,
            "order": 5,
            link: "#renewalBookings", title: "Renewal Bookings",
            "voiceover": "This chart shows renewal bookings",
            props: {
                chartTitle: 'renewal bookings',
                chartColorId: 'renewal bookings',
                drilldownAvailable: true,
                usedInPredictions: true,
                availableGlobalOnly: false,
                bottomLegend: "month",
                chartDescription: ``,
                inputType: 'currency',
                bottomLegendLabel: 'month',
                legendLabel: 'Bookings',
                // handleChartClick: 'handleSalesCycleChartClick', // Use the correct handler
                // handleDistroChartClick: "handleSalesCycleChartClickUpsell",
                isComposed: false,
                isDistroChart: true,
                showMarkers: false,
                showXMarkers: true,
                enableCustomConfig: true,
                trendLineEntry: 'curve_values',
            },
        },

        {
            id: 'churnRate',
            "visible": true,
            "order": 4,
            "voiceover": "This chart shows the churn rate.",
            link: "#churnRate",
            title: "Churn Rate",
            props: {
                chartTitle: 'churn rate',
                chartColorId: 'churn rate',
                usedInPredictions: true,
                availableGlobalOnly: false,
                drilldownAvailable: true,
                chartDescription: `This chart shows the churn rate (transaction count)`,
                inputType: 'percent',
                bottomLegendLabel: 'Month',
                legendLabel: 'Churn Rate',
                handleChartClick: 'handleChurnRateChartClick',
                // Additional props for QPilot
                qPilotEnabled: false,
                qPilotChartName: 'gtm-stats-churn-rate',
                // Note: qPilotChartDataSet will be handled in utility functions
                // Additional props for custom config
                enableCustomConfig: true,
                gtmStatsCustomConfigEntry: 'churn_rate',
            },
        },

        {
            id: 'churnArr',
            "visible": true,
            "order": 4,
            "voiceover": "This chart shows the churn ARR.",
            link: "#churnArr",
            title: "Churn ARR",
            props: {
                chartTitle: 'churn ARR',
                chartColorId: 'churn ARR',
                usedInPredictions: true,
                availableGlobalOnly: false,
                drilldownAvailable: true,
                chartDescription: `This chart shows the churn ARR (ARR)`,
                inputType: 'currency',
                bottomLegendLabel: 'Month',
                legendLabel: 'Churn (ARR)',
                handleChartClick: 'handleChurnArrChartClick',
                // Additional props for QPilot
                qPilotEnabled: false,
                qPilotChartName: 'gtm-stats-churn-arr',
                // Note: qPilotChartDataSet will be handled in utility functions
                // Additional props for custom config
                enableCustomConfig: true,
                gtmStatsCustomConfigEntry: 'churn_arr',
            },
        },
        // Include other charts as needed
    ]

